/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyVehicleProfileSerializer,
    ReadOnlyVehicleProfileSerializerFromJSON,
    ReadOnlyVehicleProfileSerializerFromJSONTyped,
    ReadOnlyVehicleProfileSerializerToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20048
 */
export interface InlineResponse20048 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20048
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20048
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20048
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyVehicleProfileSerializer>}
     * @memberof InlineResponse20048
     */
    results: Array<ReadOnlyVehicleProfileSerializer>;
}

export function InlineResponse20048FromJSON(json: any): InlineResponse20048 {
    return InlineResponse20048FromJSONTyped(json, false);
}

export function InlineResponse20048FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20048 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyVehicleProfileSerializerFromJSON)),
    };
}

export function InlineResponse20048ToJSON(value?: InlineResponse20048 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyVehicleProfileSerializerToJSON)),
    };
}


